import { render } from "./donut.vue?vue&type=template&id=5350eff3"
import script from "./donut.vue?vue&type=script&lang=js"
export * from "./donut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__